<template>
  <v-bottom-sheet
      v-model="sheet"
      scrollable
      persistent
      no-click-animation
      :overlay-opacity="0.7"
      content-class="bottom-sheet"
  >
    <v-card>
      <SheetHeader :title="'여행지 변경'" @sheetClose="$emit('sheetClose')"/>
      <v-card-subtitle>
        방문할 여행지를 선택해주세요.
      </v-card-subtitle>
      <v-card-text class="sheet-body">
        <div class="slider">
          <Flicking :options="{  align: 'center' , preventClickOnDrag: true, defaultIndex: this.defaultIndex-1}" :plugins="plugins">
            <!-- 과거 여행지 없는 경우 -->
            <div v-if="rvsOrdDtlList.length == 1" class="background-panel">
              <div v-if="memberGb == '01'" class="new-ticket" @click="newTicket">
                보유티켓을 사용하여<br>
                새로운 여행지로 이동해보세요
              </div>
              <div v-else class="new-ticket" @click="newTicket">
                티켓을 구매하여<br>
                새로운 여행지로 이동해보세요
              </div>
            </div>
            <div v-for="i in rvsOrdDtlList.length" :key="i" class="background-panel">
              <span v-if="rvsOrdDtlList[i-1].progYn == 'Y'" class="status">{{rvsOrdDtlList[i-1].useStatus == '01' ? (hasActiveTrial ? '대기' : '진행중') : '중지중'}}</span>
              <span v-else class="status">과거 여행지</span>
              <span class="date">{{rvsOrdDtlList[i-1].usePeriodStartDt}} ~ {{rvsOrdDtlList[i-1].usePeriodEndDt}}</span>
              <v-img
                  :src="getImage(bgImgArr[(i-1)%6])"
                  max-height="100%"
                  @click="travelChange(rvsOrdDtlList[i-1])"
              ></v-img>
            </div>
          </Flicking>
        </div>
      </v-card-text>
    </v-card>
  </v-bottom-sheet>
</template>

<script>
import SheetHeader from "./SheetHeader";
import { Perspective } from "@egjs/flicking-plugins";
import {mixinAuth, mixinTrial} from "@/mixins";
import Util from '@/utils/utils'
export default {
  props:["sheet","ordDtlList"],
  mixins: [mixinTrial, mixinAuth],
  data: ()=> ({
    plugins: [new Perspective({ rotate: 0, scale: 0.27 })],
    rvsOrdDtlList:[],
    defaultIndex:0,
    bgImgArr:['background/hill/day.png'
      ,'background/mountain/day.png'
      ,'background/sea/day.png'
      ,'background/mind/day.png'
      ,'background/desert/day.png'
      ,'background/space/day.png'],
  }),
  components:{
    SheetHeader,
  },
  watch: {
    ordDtlList(){
      // 복사 후 reverse 시 원본도 같이 되어 역순으로 push
      for(let i = this.ordDtlList.length; i > 0; i--) {
        this.rvsOrdDtlList.push(this.ordDtlList[i-1])
      }
      //체험권일때 여행지 기간 변경
      if (this.rvsOrdDtlList.length === 1) {
        if (this.hasActiveTrial) {
          if (this.expiredTrial) {
            this.rvsOrdDtlList[0] = {
              ...this.rvsOrdDtlList[0],
              usePeriodEndDt:''
            }
          } else {
            const strDt = Util.Date.toFormatDate(this.trialActiveDateTime, 'YYYY.MM.DD')
            const endDt = Util.Date.toFormatDate(this.trialInactiveDateTime, 'YYYY.MM.DD')
            this.rvsOrdDtlList[0] = {
              ...this.rvsOrdDtlList[0],
              usePeriodStartDt: strDt,
              usePeriodEndDt: endDt
            }
          }
        }
      }
      if (this.rvsOrdDtlList.length > 1){
        this.defaultIndex = this.rvsOrdDtlList.length
      } else {
        this.defaultIndex = 2
      }
    }
  },
  mounted() {
  },
  methods:{
    newTicket(){
      // alert('newTicket')
    },
    travelChange(ordDtl){
      this.$emit('sheetClose')
      this.$emit('travelMapChange', ordDtl)
      this.$root.$children[0].$refs.toast.toastOpen('top','여행지가 변경되었습니다.')
    }
  }

}
</script>

<style lang="scss" scoped>
::v-deep .v-dialog{
  .sheet-body{
    margin-top: -20px;
    padding:0 !important;
    .slider{
      padding: 35px 0 50px 0;
      .background-panel{
        position: relative;
        width: 190px;
        height: 248px;
        border-radius: 5px;
        overflow: hidden;
        margin-right: 10px;
        .status, .date{
          position: absolute;
          z-index: 1;
        }
        .status{
          top: 12px;
          right: 12px;
          font-size: 11px;
          font-weight: 500;
          color: #fff;
          background: #000;
          padding: 5px 7px;
          border-radius: 20px;
          line-height: 1;
        }
        .date{
          bottom: 14px;
          text-align: center;
          font-weight: 500;
          width: 100%;
          color: #fff;
          text-shadow: 0px 2px 6px #000000BE;
        }
        &:last-child{
          margin-right: 0;
        }
        .new-ticket{
          height: 100%;
          background: #F0F0F0;
          color: #9FA9B4;
          display: flex;
          justify-content: center;
          align-items: center;
          text-align: center;
        }
      }
    }
  }
}
</style>
